import React from "react";
import { Fade } from "react-reveal";
import html from "../assets/html.png";
import css from "../assets/css.png";
import javascript from "../assets/javascript.png";
import react from "../assets/react.png";
import node from "../assets/node.png";
import firebase from "../assets/firebase.png";
import express from "../assets/express.png";
import github from "../assets/github.png";
import git from "../assets/git.png";
import tailwind from "../assets/tailwind.png";
import bootstrap from "../assets/bootstrap.png";
import mongo from "../assets/mongo.png";

const Skills = () => {
  return (
    <Fade bottom duration={1500} distance="100px">
      <div
        name="skills"
        className="w-full h-full bg-[#1d375f] text-gray-300 mt-6"
      >
        <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full">
          <div>
            <p className="text-4xl font-bold inline border-b-4 border-yellow-400 ">
              Skills
            </p>
            <p className="py-4 font-semibold">
              <span className="text-pink-600">`// </span>
              CRAZY DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK
              <span className="text-yellow-400">.//</span>
            </p>
          </div>

          {/* shadow-[#040c16] */}

          <div className="w-full grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-8">
            <div className="shadow-lg shadow-[#040c16] hover:scale-110 duration-300">
              <img className="w-20 mx-auto" src={html} alt="HTML icon" />
              <p className="my-4">HTML</p>
            </div>
            <div className="shadow-lg shadow-[#040c16] hover:scale-110 duration-300">
              <img className="w-20 mx-auto" src={css} alt="HTML icon" />
              <p className="my-4">CSS</p>
            </div>
            <div className="shadow-lg shadow-[#040c16] hover:scale-110 duration-300">
              <img className="w-20 mx-auto" src={bootstrap} alt="HTML icon" />
              <p className="my-4">BOOTSTRAP</p>
            </div>
            <div className="shadow-lg shadow-[#040c16] hover:scale-110 duration-300">
              <img className="w-20 mx-auto" src={tailwind} alt="HTML icon" />
              <p className="my-4">TAILWIND</p>
            </div>
            <div className="shadow-lg shadow-[#040c16] hover:scale-110 duration-300">
              <img className="w-20 mx-auto" src={javascript} alt="HTML icon" />
              <p className="my-4">JAVASCRIPT</p>
            </div>
            <div className="shadow-lg shadow-[#040c16] hover:scale-110 duration-300">
              <img className="w-20 mx-auto" src={react} alt="HTML icon" />
              <p className="my-4">REACT</p>
            </div>
            <div className="shadow-lg shadow-[#040c16] hover:scale-110 duration-300">
              <img className="w-20 mx-auto" src={git} alt="HTML icon" />
              <p className="my-4">GIT</p>
            </div>
            <div className="shadow-lg shadow-[#040c16] hover:scale-110 duration-300">
              <img className="w-20 mx-auto" src={github} alt="HTML icon" />
              <p className="my-4">GITHUB</p>
            </div>
            <div className="shadow-lg shadow-[#040c16] hover:scale-110 duration-300">
              <img className="w-20 mx-auto" src={firebase} alt="HTML icon" />
              <p className="my-4">FIREBASE</p>
            </div>
            <div className="shadow-lg shadow-[#040c16] hover:scale-110 duration-300">
              <img className="w-20 mx-auto" src={node} alt="HTML icon" />
              <p className="my-4">NODE JS</p>
            </div>
            <div className="shadow-lg shadow-[#040c16] hover:scale-110 duration-300">
              <img className="w-20 mx-auto" src={express} alt="HTML icon" />
              <p className="my-4">EXPRESS JS</p>
            </div>
            <div className="shadow-lg shadow-[#040c16] hover:scale-110 duration-300">
              <img className="w-20 mx-auto" src={mongo} alt="HTML icon" />
              <p className="my-4">MONGO DB</p>
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default Skills;
